import * as React from "react";
const Wallet = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", fill: "currentColor", ...props },
    React.createElement("path", { fill: "none", d: "M0 0h256v256H0z" }),
    React.createElement("circle", { cx: 180, cy: 136, r: 16 }),
    React.createElement("path", { d: "M40 60.73V180a20 20 0 0 0 20 20h144a20 20 0 0 0 20-20v-80a20 20 0 0 0-20-20H60.48C49.63 80 40.4 71.57 40 60.73A20 20 0 0 1 60 40h132", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 24 })));
export default Wallet;
